<div class="client-fields" [class.client-fields--double]="layout() === 'double'">
  @for (group of groups(); track group.label) {
    @if (group.label) {
      <div class="client-fields__wide client-fields__section">
        <span class="client-fields__section-title">{{ group.label }}</span>
      </div>
    }

    @for (entry of group.entries; track entry.field.key) {
      <div class="client-fields__field">
        <app-input
          [id]="'client-contract-field-' + entry.field.key"
          [label]="entry.field.label"
          type="number"
          [prefix]="entry.field.kind === 'Money' ? 'R$ ' : ''"
          [suffix]="entry.field.kind === 'Percent' ? ' %' : ''"
          [min]="entry.field.min ?? undefined"
          [max]="entry.field.max ?? undefined"
          [minFractionDigits]="entry.field.decimals"
          [maxFractionDigits]="entry.field.decimals"
          [formControl]="entry.control" />
        <div class="client-fields__default-row">
          <span class="client-fields__default-hint">{{ defaultHint(entry.field) }}</span>
          @if (isOutOfDefault(entry.field, entry.control.value)) {
            <span
              class="client-fields__off-default"
              pTooltip="Valor diferente do padrão: o envio vai pedir aprovação">
              Fora do padrão
            </span>
          }
        </div>
      </div>
    }
  }

  @if (form().hasBlock('economicGroup')) {
    <div class="client-fields__wide client-fields__block">
      <div class="client-fields__block-header">
        <app-switch
          [label]="blockLabel('economicGroup')"
          [checked]="economicGroupEnabled()"
          [disabled]="readonly()"
          (sendChecked)="toggleEconomicGroup($event)" />
      </div>
      @if (blockDescription('economicGroup')) {
        <p class="client-fields__block-hint">{{ blockDescription('economicGroup') }}</p>
      } @else {
        <p class="client-fields__block-hint">
          Ligado, a cláusula das empresas do grupo entra no texto, com a lista abaixo.
        </p>
      }

      @if (economicGroupEnabled()) {
        <div class="client-fields__companies">
          @for (row of groupCompanyRows(); track row; let index = $index) {
            <div class="client-fields__company-row">
              <app-input
                [id]="'client-contract-group-name-' + index"
                label="Razão social"
                placeholder="Ex.: Empresa B Ltda."
                [maxLength]="300"
                [formControl]="row.controls.name" />
              <app-input
                [id]="'client-contract-group-cnpj-' + index"
                label="CNPJ"
                type="cnpj"
                placeholder="00.000.000/0000-00"
                [unmask]="true"
                [formControl]="row.controls.cnpj" />
              @if (!readonly()) {
                <app-button
                  icon="pi pi-trash"
                  [text]="true"
                  [pureIcon]="true"
                  ariaLabel="Tirar a empresa da lista"
                  pTooltip="Tirar a empresa da lista"
                  tooltipPosition="left"
                  (sendButtonClick)="removeGroupCompany(index)" />
              }
            </div>
          } @empty {
            <p class="client-fields__empty">
              Nenhuma empresa na lista. Para finalizar o contrato com este bloco ligado, inclua ao
              menos uma.
            </p>
          }

          @if (!readonly()) {
            <div class="client-fields__company-actions">
              <app-button
                label="Adicionar empresa"
                icon="pi pi-plus"
                theme="white"
                size="small"
                (sendButtonClick)="addGroupCompany()" />
              @if (companyId()) {
                <app-button
                  label="Buscar do grupo econômico"
                  icon="pi pi-sitemap"
                  theme="white"
                  size="small"
                  [isLoading]="loadingGroupCompanies()"
                  loadingText="Buscando..."
                  (sendButtonClick)="loadGroupCompanies()" />
              }
            </div>
          }
        </div>
      }
    </div>
  }

  @if (form().hasBlock('exclusivityException')) {
    <div class="client-fields__wide client-fields__block">
      <div class="client-fields__block-header">
        <app-switch
          [label]="blockLabel('exclusivityException')"
          [checked]="exclusivityEnabled()"
          [disabled]="readonly()"
          (sendChecked)="toggleExclusivity($event)" />
      </div>
      @if (blockDescription('exclusivityException')) {
        <p class="client-fields__block-hint">{{ blockDescription('exclusivityException') }}</p>
      } @else {
        <p class="client-fields__block-hint">
          Ligado, a cláusula de exclusividade ressalva as operações já existentes com a instituição
          abaixo.
        </p>
      }

      @if (exclusivityEnabled()) {
        <app-input
          id="client-contract-exclusivity-institution"
          label="Instituição financeira"
          placeholder="Ex.: Banco X S.A."
          [maxLength]="300"
          [formControl]="form().exclusivityInstitution" />
      }
    </div>
  }
</div>
